import { z } from "zod";
import { scopeTypeSchema, uuidSchema, verificationMethodSchema } from "./common";

/** `POST /v1/scopes` body. Mirrors `CreateScope` in routes_core.rs. */
export const createScopeSchema = z.object({
  scope_type: scopeTypeSchema,
  value: z.string().trim().min(1, "value is required").max(512),
  verification_method: verificationMethodSchema,
  expires_at: z.string().optional().or(z.literal("")),
});
export type CreateScopeInput = z.infer<typeof createScopeSchema>;

export const createScopeResultSchema = z.object({
  id: uuidSchema,
  verification_token: z.string().nullable(),
  dns_record: z.string().nullable(),
  well_known_path: z.string().nullable(),
});
